import { BellContained, BellOutlined } from '@sgcmpteltd/uikit-react';
import Image from 'next/image';
import { useTransition } from 'react';

import { BELL_ALERT_ICON_SIZE, WHATSAPP_ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Footer: Component = ({
  onAlertAdd,
  isUserLogin,
  whatsAppLink,
  isAddToAlert,
}) => {
  const [
    isAddAlertPending,
    startAddAlertTransition,
  ] = useTransition();

  let alertButtonContent;

  if (!isUserLogin) {
    alertButtonContent = (
      <div className={styles.textButton}>
        <BellOutlined size={BELL_ALERT_ICON_SIZE} />
        Add to Alert
      </div>
    );
  } else if (isAddToAlert) {
    alertButtonContent = (
      <div className={styles.textButton}>
        <BellContained size={BELL_ALERT_ICON_SIZE} />
        Remove Alert
      </div>
    );
  } else {
    alertButtonContent = (
      <div className={styles.textButton}>
        <BellOutlined size={BELL_ALERT_ICON_SIZE} />
        Add to Alert
      </div>
    );
  }

  return (
    <div
      className={styles.containerRoot}>
      <div
        className={styles.containerControlSet}>
        <div
          className={styles.containerButtonControlSet}>
          <div
            className={styles.containerAddToAlertButton}>
            <button
              className={styles.buttonAddToAlert}
              disabled={isAddAlertPending}
              onClick={() => {
                startAddAlertTransition(async () => {
                  await onAlertAdd?.();
                });
              }}>
              {alertButtonContent}
            </button>
          </div>
          { whatsAppLink !== ''
            ? (
              <div
                className={styles.containerWhatsAppButton}>
                <a
                  href={whatsAppLink}
                  rel="noreferrer noopener"
                  target="_blank">
                  <button
                    className={styles.buttonWhatsApp}>
                    <Image
                      alt="whatsapp icon"
                      className={styles.iconExclamationMark}
                      height={WHATSAPP_ICON_SIZE}
                      src="https://media.i-sgcm.com/public/new-cars/icon/iconWhatsApp.svg"
                      width={WHATSAPP_ICON_SIZE} />
                    WhatsApp
                  </button>
                </a>
              </div>
            )
            : null}

        </div>
      </div>
    </div>
  );
};
